import { DataTableColumn, FilterType } from '../DataTable.types';

type FilterOption = { label: string; value: string | null };

/**
 * Prepends (or appends) a "Not Set" option to a MULTI_SELECT filter's options so users can
 * filter for records where the field is unset/null. Default-on for every MULTI_SELECT column;
 * opt out per column with filterConfig.nullValueOption.enabled === false. Pure — safe to call
 * on already-resolved options at render time.
 */
export function withNullValueOption(column: DataTableColumn, options: FilterOption[]): FilterOption[] {
    const fc = column?.filterConfig;
    if (fc?.filterType !== FilterType.MULTI_SELECT) return options;
    const nvo = fc?.nullValueOption;
    if (nvo?.enabled === false) return options;
    if (options.some((option) => option?.value === null)) return options;
    const nullOption: FilterOption = { label: nvo?.label || 'Not Set', value: null };
    return nvo?.position === 'bottom' ? [...options, nullOption] : [nullOption, ...options];
}
